// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DespesasCategorias_CarregaCategoriasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/despesas_categorias/carrega_categorias
 *
 * Returns the full list of expense categories, ordered by titulo ASC.
 */
import type { DespesasCategorias_CategoriaRow } from './DespesasCategorias_CategoriaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type DespesasCategorias_CarregaCategoriasResponseDados = DespesasCategorias_CategoriaRow[];

export type DespesasCategorias_CarregaCategoriasResponse = ApiResponse<DespesasCategorias_CarregaCategoriasResponseDados>;

registerResponseContract('DespesasCategorias_CarregaCategoriasResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      despesa_categoria_id:                { type: 'number',  required: true },
      despesa_categoria_titulo:            { type: 'string',  required: true },
      despesa_categoria_status:            { type: 'number',  required: true },
      despesa_categoria_investimento:      { type: 'number',  required: true },
      despesa_categoria_percentual_padrao: { type: 'number',  required: true },
      despesa_categoria_grupo_dre:         { type: 'string',  required: false },
    },
  },
})
